import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import Select from 'react-select';

// Styles
import { FormStyled, Row, Column } from '../../css/styles/form';
import { SelectStyled } from '../../css/styles/select';

const handleValidate = ({ description }) => {
  const errors = {};
  if (!description) errors.description = 'OBRIGATÓRIO';
  return errors;
};

const handleSubmit = props => async (values, { setSubmitting, resetForm }) => {
  if (!props.piece) {
    await props.onCreation({ ...values });
  } else {
    await props.onUpdate({ ...values });
  }
  setSubmitting(false);
  resetForm();
};

const PieceForm = props => {
  const { onDelete, onNew, onEdit, piece, pieces } = props;

  return (
    <Formik
      enableReinitialize
      initialValues={{
        description: piece ? piece.description : '',
        // total: piece? piece.total : ''
      }}
      validate={handleValidate}
      onSubmit={handleSubmit(props)}
    >
      {({
        values,
        handleChange,
        handleBlur,
        handleReset,
        isSubmitting,
        setFieldValue,
        dirty,
        errors,
        touched,
      }) => (
        <FormStyled>
          <h1>NOVA PEÇA</h1>

          <ul>
            <Row>
              <Column>
                <strong>DESCRIÇÃO</strong>
                <textarea
                  id="description"
                  name="description"
                  type="text"
                  value={values.description}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />

                {errors.description && touched.description && (
                  <span>{errors.description}</span>
                )}
              </Column>
            </Row>

            {/* <Row>
              <Column>
                <strong>QUANTIDADE TOTAL</strong>
                <input
                  id="total"
                  name="total"
                  type="number"
                  value={values.total}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />

                {errors.description && touched.description && (
                  <span>{errors.description}</span>
                )}
              </Column>
            </Row> */}

            <Row>
              <div className="buttons-container">
                <button type="submit" disabled={isSubmitting}>
                  SALVAR
                </button>

                <button
                  type="button"
                  onClick={handleReset}
                  disabled={!dirty || isSubmitting}
                >
                  RESET
                </button>

                {piece && (
                  <>
                    <button type="button" onClick={onNew}>
                      LIMPAR
                    </button>

                    <button className="delete" type="button" onClick={onDelete}>
                      EXCLUIR
                    </button>
                  </>
                )}
              </div>
            </Row>
          </ul>

          <hr />

          <ul>
            <Row>
              <Column>
                <strong>PEÇA</strong>
                <Select
                  styles={SelectStyled}
                  id="piece"
                  value={values.piece}
                  placeholder="Selecione uma peça"
                  onChange={selectedOption => {
                    setFieldValue('piece', selectedOption);
                    onEdit(selectedOption);
                  }}
                  isSearchable
                  options={pieces}
                  getOptionLabel={item => item.description}
                  getOptionValue={item => item.uuid}
                  name="piece"
                  isLoading={false}
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                  loadingMessage={() => 'Buscando peças'}
                  noOptionsMessage={() => 'Não há peças cadastrados'}
                />
              </Column>
            </Row>
          </ul>
        </FormStyled>
      )}
    </Formik>
  );
};

PieceForm.propTypes = {
  pieces: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
    })
  ),
  piece: PropTypes.shape({
    description: PropTypes.string,
  }),
  onDelete: PropTypes.func.isRequired,
  onNew: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
};

PieceForm.defaultProps = {
  pieces: [],
  piece: null,
};

export default PieceForm;
